export enum ReservationStatusType {
    Waiting,
    Confirmed,
    Finished,
    Canceled,
    DontShowUp
}